import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/images/sign_img.png';
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 translate-z-0 bg-white/10 z-50"
};
import useMeStore from '@/features/auth/useMeStore';
import { reactive, onMounted, getCurrentInstance } from 'vue';
export default {
  __name: 'integralSignMask',
  setup(__props) {
    const meStore = useMeStore();
    const {
      proxy
    } = getCurrentInstance();
    const popupState = reactive({
      show: false,
      popup: {
        show: true
      }
    });
    onMounted(() => {
      if (meStore.me.user_type == 1 || meStore.me.is_regional == 1) return;
      let is_sign = localStorage.getItem('is_sign') || false,
        day_end = localStorage.getItem('day_end') || 0,
        day_sart = new Date().getTime();
      if (!is_sign || day_end - day_sart < 0) {
        proxy.$api.loginIntegral().then(res => {
          if (res.code == 1) {
            popupState.show = true;
            localStorage.setItem('is_sign', true);
            day_end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime();
            localStorage.setItem('day_end', day_end);
          }
        });
        setTimeout(() => {
          popupState.show = false;
        }, 2000);
      }
    });
    const maskClick = () => {
      setTimeout(() => {
        popupState.show = false;
      }, 100);
    };
    return (_ctx, _cache) => {
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", null, [popupState.show ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true), popupState.show ? (_openBlock(), _createBlock(_component_van_popup, {
        key: 1,
        show: popupState.popup.show,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => popupState.popup.show = $event),
        onClose: _cache[2] || (_cache[2] = $event => maskClick())
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "fixed-box",
          onClick: _cache[0] || (_cache[0] = $event => maskClick())
        }, _cache[3] || (_cache[3] = [_createElementVNode("img", {
          src: _imports_0,
          class: "img-box"
        }, null, -1), _createElementVNode("div", {
          class: "abso-box"
        }, [_createElementVNode("div", null, "恭喜您"), _createElementVNode("div", null, "成功领取1积分")], -1)]))]),
        _: 1
      }, 8, ["show"])) : _createCommentVNode("", true)]);
    };
  }
};